import { Component, Input, OnInit } from '@angular/core';
import { VersionInfoDialogComponent } from './version-info/version-info.component';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { environment } from 'src/environments/environment';
import { config } from 'src/config/config';
import { Router } from '@angular/router';
import { PATH_CONSTANTS } from 'src/app/shared/constants/path-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import {
  convertParseDateTimeLangSpecific,
  extractDateTimeFromDateString
} from 'src/app/shared/utils/utility.service';
import { enUS, fr } from 'date-fns/locale';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { format, parse } from 'date-fns';
import { BRANDS } from 'src/app/shared/models/screen-size.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer-lower',
  templateUrl: './footer-lower.component.html',
  styleUrls: ['./footer-lower.component.scss'],
})
export class FooterLowerComponent implements OnInit {
  @Input() sizeClass: String | undefined;
  appVersion = config.VERSION_INFO.APP_VERSION;
  releaseDate = config.VERSION_INFO.RELEASE_DATE;
  readonly LANG_CONST = LANG_CONST;
  readonly PATH_CONSTANTS = PATH_CONSTANTS;
  copyRights: string | undefined;

  constructor(private translate: TranslateService, private helperService: HelperService, private router: Router, private localizationService: LocalizationService, private stateManagementService: StateManagementService) {
    this.localizationService.setupLocalization();
  }

  ngOnInit(): void {
    this.translate.get('COPY_RIGHT_ALL_RESERVED').subscribe((translation: string) => {
      this.copyRights = translation;
    });
  }

  openVersionInfo() {    
    const locale = this.stateManagementService.getUserLanguage();
    const lang = locale === LANG_CONST.FRENCH ? fr : enUS;
    const formatDate = locale === LANG_CONST.FRENCH ? "MMMM d yyyy" : "MMMM do yyyy"
    let date = format(
      parse(String(this.releaseDate), "MMMM do yyyy", new Date()),
      formatDate,
      { locale: lang }
    );
    date = date.charAt(0).toUpperCase() + date.slice(1);
    const dialogInstance = this.helperService.openModalDialog(
      VersionInfoDialogComponent,
      {
        version: this.appVersion,
        date: date
      }
    );
  }
  // this function is getting navigated to link of Privacy Policy
  navigateToPrivacyPolicy() {
    this.router.navigateByUrl(PATH_CONSTANTS.PRIVACY_POLICY);
  }

  // this function is getting navigated to link  of Terms of Use
  navigateToTermsOfUse() {
    this.router.navigateByUrl(PATH_CONSTANTS.TERMS_OF_USE);
  }

  navigateToTermsOfService() {
    const brand = this.stateManagementService?.getUserBrand();
    const Lang = this.stateManagementService?.getUserLanguage();
    if(brand === BRANDS.WEISER){
      if(Lang === LANG_CONST.FRENCH) {
        window.open(CONSTANTS.TERMS_OF_SERVICE_FRENCH_WEISER, '_blank');
      }
      else {
        window.open(CONSTANTS.TERMS_OF_SERVICE_WEISER, '_blank');
      }
    }
    else {
      window.open(CONSTANTS.TERMS_OF_SERVICE, '_blank');
    }
  }

  // this function is getting navigated to link of Web Accessibilty
  navigateToWebAccessibilty() {
    const brand = this.stateManagementService?.getUserBrand();
    const Lang = this.stateManagementService?.getUserLanguage();
    if(brand === BRANDS.WEISER){
      if(Lang === LANG_CONST.FRENCH) {
        window.open(CONSTANTS.WEB_ACCESSIBILITY_FRENCH_WEISER, '_blank');
      }
      else {
        window.open(CONSTANTS.WEB_ACCESSIBILITY_WEISER, '_blank');
      }
    }
    else {
      window.open(CONSTANTS.WEB_ACCESSIBILITY, '_blank');
    }
  }

  // this function is getting navigated to link of Product
  navigateToProduct(): void {
    const brand = this.stateManagementService?.getUserBrand();
    const Lang = this.stateManagementService?.getUserLanguage();
    if(brand === BRANDS.WEISER){
      if(Lang === LANG_CONST.FRENCH) {
        window.open(CONSTANTS.PRODUCT_LINK_FRENCH_WEISER, '_blank');
      }
      else {
        window.open(CONSTANTS.PRODUCT_LINK_WEISER, '_blank');
      }
    }
    else {
      window.open(CONSTANTS.PRODUCT_LINK, '_blank');
    }
  }

  // this function is getting navigated to link of Support Center
  navigateToSupportCenter(): void {
    const brand = this.stateManagementService?.getUserBrand();
    const Lang = this.stateManagementService?.getUserLanguage();
    if(brand === BRANDS.WEISER){
      if(Lang === LANG_CONST.FRENCH) {
        window.open(CONSTANTS.SUPPORT_CENTER_FRENCH_WEISER, '_blank');
      }
      else {
        window.open(CONSTANTS.SUPPORT_CENTER_WEISER, '_blank');
      }
    }
    else {
      window.open(CONSTANTS.SUPPORT_CENTER, '_blank');
    }
  }

  // this function is getting navigated to link of Apps
  navigateToApps(): void {
    const brand = this.stateManagementService?.getUserBrand();
    const Lang = this.stateManagementService?.getUserLanguage();
    if(brand === BRANDS.WEISER){
      if(Lang === LANG_CONST.FRENCH) {
        window.open(CONSTANTS.APPS_LINK_FRENCH_WEISER, '_blank');
      }
      else {
        window.open(CONSTANTS.APPS_LINK_WEISER, '_blank');
      }
    }
    else {
      window.open(CONSTANTS.APPS_LINK, '_blank');
    }
  }

}
